var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card",
        { staticClass: "mb-5" },
        [
          _c("v-card-title", { staticClass: "card-title" }, [
            _vm._v("Datos del puesto"),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { staticClass: "pa-3" },
                [
                  _c(
                    "v-col",
                    { staticClass: "py-1", attrs: { cols: "12", md: "4" } },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mb-2" },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-2 icon-chevron",
                            attrs: { icon: "chevron-right" },
                          }),
                          _c("v-label", { staticClass: "label-input" }, [
                            _vm._v("Nombre del puesto*"),
                          ]),
                        ],
                        1
                      ),
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|max:150",
                            expression: "'required|max:150'",
                          },
                        ],
                        attrs: {
                          name: "name",
                          "data-vv-as": "nombre del puesto",
                          disabled: _vm.disabled,
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.item.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.item, "name", $$v)
                          },
                          expression: "item.name",
                        },
                      }),
                      _c("span", { staticClass: "red--text" }, [
                        _vm._v(_vm._s(_vm.errors.first("name"))),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "py-1", attrs: { cols: "12", md: "4" } },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mb-2" },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-2 icon-chevron",
                            attrs: { icon: "chevron-right" },
                          }),
                          _c("v-label", { staticClass: "label-input" }, [
                            _vm._v("Tipo de nodo*"),
                          ]),
                        ],
                        1
                      ),
                      _c("v-select", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: {
                          name: "node_type",
                          "data-vv-as": "tipo de nodo",
                          items: _vm.node_types,
                          "item-text": "name",
                          "item-value": "id",
                          "return-object": "",
                          disabled: _vm.disabled,
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.item.node_type,
                          callback: function ($$v) {
                            _vm.$set(_vm.item, "node_type", $$v)
                          },
                          expression: "item.node_type",
                        },
                      }),
                      _c("span", { staticClass: "red--text" }, [
                        _vm._v(_vm._s(_vm.errors.first("node_type"))),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "py-1", attrs: { cols: "12", md: "4" } },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mb-2" },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-2 icon-chevron",
                            attrs: { icon: "chevron-right" },
                          }),
                          _c("v-label", { staticClass: "label-input" }, [
                            _vm._v("Referencia externa"),
                          ]),
                        ],
                        1
                      ),
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "max:255",
                            expression: "'max:255'",
                          },
                        ],
                        attrs: {
                          name: "external_reference",
                          "data-vv-as": "referencia externa",
                          disabled: _vm.disabled,
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.item.external_reference,
                          callback: function ($$v) {
                            _vm.$set(_vm.item, "external_reference", $$v)
                          },
                          expression: "item.external_reference",
                        },
                      }),
                      _c("span", { staticClass: "red--text" }, [
                        _vm._v(_vm._s(_vm.errors.first("external_reference"))),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "py-1", attrs: { cols: "12", md: "4" } },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mb-2" },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-2 icon-chevron",
                            attrs: { icon: "chevron-right" },
                          }),
                          _c("v-label", { staticClass: "label-input" }, [
                            _vm._v("Sucursal*"),
                          ]),
                        ],
                        1
                      ),
                      _c("v-select", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        attrs: {
                          name: "sucursal",
                          "data-vv-as": "sucursal",
                          items: _vm.sucursales,
                          "item-text": "name",
                          "item-value": "id",
                          "return-object": "",
                          disabled: _vm.disabled,
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.item.sucursal,
                          callback: function ($$v) {
                            _vm.$set(_vm.item, "sucursal", $$v)
                          },
                          expression: "item.sucursal",
                        },
                      }),
                      _c("span", { staticClass: "red--text" }, [
                        _vm._v(_vm._s(_vm.errors.first("sucursal"))),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "py-1", attrs: { cols: "12", md: "4" } },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mb-2" },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-2 icon-chevron",
                            attrs: { icon: "chevron-right" },
                          }),
                          _c("v-label", { staticClass: "label-input" }, [
                            _vm._v("Sector"),
                          ]),
                        ],
                        1
                      ),
                      _c("v-select", {
                        attrs: {
                          items: _vm.worksectors,
                          "item-text": "name",
                          "item-value": "id",
                          "return-object": "",
                          clearable: "",
                          disabled: _vm.disabled,
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.item.worksector,
                          callback: function ($$v) {
                            _vm.$set(_vm.item, "worksector", $$v)
                          },
                          expression: "item.worksector",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "py-1", attrs: { cols: "12", md: "4" } },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mb-2" },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-2 icon-chevron",
                            attrs: { icon: "chevron-right" },
                          }),
                          _c("v-label", { staticClass: "label-input" }, [
                            _vm._v("Estado"),
                          ]),
                        ],
                        1
                      ),
                      _c("v-select", {
                        attrs: {
                          items: _vm.status_options,
                          disabled: _vm.disabled,
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.item.enabled,
                          callback: function ($$v) {
                            _vm.$set(_vm.item, "enabled", $$v)
                          },
                          expression: "item.enabled",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "py-1", attrs: { cols: "12" } },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mb-2" },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-2 icon-chevron",
                            attrs: { icon: "chevron-right" },
                          }),
                          _c("v-label", { staticClass: "label-input" }, [
                            _vm._v("Descripción / funciones"),
                          ]),
                        ],
                        1
                      ),
                      _c("v-textarea", {
                        attrs: {
                          rows: "3",
                          "auto-grow": "",
                          disabled: _vm.disabled,
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.item.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.item, "description", $$v)
                          },
                          expression: "item.description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "mb-5" },
        [
          _c("v-card-title", { staticClass: "card-title" }, [
            _vm._v("Posición en el organigrama"),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { staticClass: "pa-3" },
                [
                  _c(
                    "v-col",
                    { staticClass: "py-1", attrs: { cols: "12", md: "4" } },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mb-2" },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-2 icon-chevron",
                            attrs: { icon: "chevron-right" },
                          }),
                          _c("v-label", { staticClass: "label-input" }, [
                            _vm._v(
                              "Depende de" +
                                _vm._s(_vm.parent_required ? "*" : "")
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c("v-autocomplete", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: _vm.parent_required ? "required" : "",
                            expression: "parent_required ? 'required' : ''",
                          },
                        ],
                        attrs: {
                          name: "parent",
                          "data-vv-as": "depende de",
                          items: _vm.parent_options,
                          "item-text": "name",
                          "item-value": "id",
                          "return-object": "",
                          clearable: "",
                          disabled: _vm.disabled,
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.item.parent,
                          callback: function ($$v) {
                            _vm.$set(_vm.item, "parent", $$v)
                          },
                          expression: "item.parent",
                        },
                      }),
                      _c("span", { staticClass: "red--text" }, [
                        _vm._v(_vm._s(_vm.errors.first("parent"))),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "py-1", attrs: { cols: "12", md: "4" } },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mb-2" },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-2 icon-chevron",
                            attrs: { icon: "chevron-right" },
                          }),
                          _c("v-label", { staticClass: "label-input" }, [
                            _vm._v("Orden entre pares"),
                          ]),
                        ],
                        1
                      ),
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "integer|min_value:0",
                            expression: "'integer|min_value:0'",
                          },
                        ],
                        attrs: {
                          name: "sort_order",
                          "data-vv-as": "orden",
                          type: "number",
                          min: "0",
                          disabled: _vm.disabled,
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.item.sort_order,
                          callback: function ($$v) {
                            _vm.$set(_vm.item, "sort_order", $$v)
                          },
                          expression: "item.sort_order",
                        },
                      }),
                      _c("span", { staticClass: "red--text" }, [
                        _vm._v(_vm._s(_vm.errors.first("sort_order"))),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "py-1", attrs: { cols: "12", md: "4" } },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mb-2" },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-2 icon-chevron",
                            attrs: { icon: "chevron-right" },
                          }),
                          _c("v-label", { staticClass: "label-input" }, [
                            _vm._v("Dependientes al abrir"),
                          ]),
                        ],
                        1
                      ),
                      _c("v-select", {
                        attrs: {
                          items: _vm.collapsed_options,
                          disabled: _vm.disabled,
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.item.children_collapsed,
                          callback: function ($$v) {
                            _vm.$set(_vm.item, "children_collapsed", $$v)
                          },
                          expression: "item.children_collapsed",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "mb-5" },
        [
          _c("v-card-title", { staticClass: "card-title" }, [
            _vm._v("Responsable"),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { staticClass: "pa-3", attrs: { align: "center" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "py-1", attrs: { cols: "12", md: "4" } },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mb-2" },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-2 icon-chevron",
                            attrs: { icon: "chevron-right" },
                          }),
                          _c("v-label", { staticClass: "label-input" }, [
                            _vm._v("Legajo responsable"),
                          ]),
                        ],
                        1
                      ),
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.legajo_options,
                          "item-text": _vm.legajoText,
                          "item-value": "id",
                          "return-object": "",
                          clearable: "",
                          placeholder: "Sin asignar",
                          loading: _vm.loading_legajos,
                          disabled: _vm.disabled,
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.item.legajo,
                          callback: function ($$v) {
                            _vm.$set(_vm.item, "legajo", $$v)
                          },
                          expression: "item.legajo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "py-1", attrs: { cols: "12", md: "4" } },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center mb-2" },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-2 icon-chevron",
                            attrs: { icon: "chevron-right" },
                          }),
                          _c("v-label", { staticClass: "label-input" }, [
                            _vm._v("Suplente"),
                          ]),
                        ],
                        1
                      ),
                      _c("v-autocomplete", {
                        attrs: {
                          name: "substitute",
                          items: _vm.substitute_options,
                          "item-text": _vm.legajoText,
                          "item-value": "id",
                          "return-object": "",
                          clearable: "",
                          placeholder: "Sin suplente",
                          loading: _vm.loading_legajos,
                          disabled: _vm.disabled,
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.item.substitute,
                          callback: function ($$v) {
                            _vm.$set(_vm.item, "substitute", $$v)
                          },
                          expression: "item.substitute",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "py-1", attrs: { cols: "12", md: "4" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "mt-3",
                        attrs: {
                          label: "Puesto vacante (sin responsable)",
                          disabled: _vm.disabled,
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.is_vacant,
                          callback: function ($$v) {
                            _vm.is_vacant = $$v
                          },
                          expression: "is_vacant",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }